/**
 * Returns the cash amount rendered as the primary price by LuxPlusPriceStack.
 * This intentionally mirrors its visual hierarchy rather than deciding whether
 * a customer is eligible for a member price.
 */
export default function getLuxPlusPrimaryCashPrice(
  price: number,
  memberPrice: number,
  displayedMode: App.LuxPlusPriceStackMode,
  isGoogleHotelAds: boolean,
  isGhaPricing: boolean,
): number {
  switch (displayedMode) {
    case 'regular-only':
      return price
    case 'regular-prominent':
      return (isGoogleHotelAds || isGhaPricing) ? price : memberPrice || price
    case 'member-only':
    case 'member-prominent':
    case 'member-compact':
    case 'member-checkout-total':
    case 'regular-with-luxPlus':
      return memberPrice || price
  }
}
